import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { NotificationListProvider } from './NotificationList.Context/NotificationList.Context.es.js';
import { NotificationListItem } from './NotificationList.Item/NotificationList.Item.es.js';

const NotificationList = ({ children, className, loading, locale, ...rest })=>jsx(NotificationListProvider, {
        loading: loading,
        locale: locale,
        children: jsx("ul", {
            "aria-live": "polite",
            "aria-relevant": "additions",
            className: classNames('cb-notification-list', className),
            ...rest,
            children: children
        })
    });
NotificationList.displayName = 'NotificationList';
NotificationList.Item = NotificationListItem;

export { NotificationList, NotificationList as default };
//# sourceMappingURL=NotificationList.es.js.map
